/*
 * @Description:本地缓存工具类
 * @Author: gonghong
 * @Date: 2024-02-19 16:28:50
 * @LastEditTime: 2024-02-27 11:26:31
 */
// eslint-disable-next-line no-unused-vars
class Storage {
    /**
     * @description: 设置localStorage缓存
     * @param {*} key
     * @param {*} val
     * @param {*} expire
     * @return {*}
     */
    static setLocal(key, val){
        window.localStorage.setItem(key, val)
    }
    /**
     * @description: 通过key获取localStorage缓存
     * @param {*} key
     * @return {*}
     */
    static getLocal(key){
        const stringData = window.localStorage.getItem(key)
        return stringData
    }
    /**
     * @description: localStorage删除对应key得缓存
     * @param {*} key
     * @return {*}
     */
    static removeLocal(key){
        window.localStorage.removeItem(key)
    }
    // static clearLocal() {
    //     window.localStorage.clear()
    // }
    static clearLocal(){
        // console.log('key', key);
        window.localStorage.clear()
    }
    /**
     * @description: 设置本地session缓存
     * @param {*} key
     * @param {*} val
     * @param {*} expire
     * @return {*}
     */
    static setSession(key, val, expire){
        let _expire = null
        if (expire) {
            _expire = new Date().getTime() + expire * 1000
        }
        const stringData = JSON.stringify({
            val,
            expire: _expire,
        })
        window.sessionStorage.setItem(key, stringData)
    }
    /**
     * @description: 获取对应key的session缓存值
     * @param {*} key
     * @return {*}
     */
    static getSession(key){
        const item = window.sessionStorage.getItem(key)
        if (item) {
            try {
                const data = JSON.parse(item)
                const { val, expire } = data
                // 在有效期内直接返回
                if (expire && expire < Date.now()) {
                    // 过期折删除该key
                    this.removeSession(key)
                }
                return val
            }
            catch {
                return null
            }
        }
        return null
    }
    /**
     * @description: 移除session对于key的缓存
     * @param {*} key
     * @return {*}
     */
    static removeSession(key){
        window.sessionStorage.removeItem(key)
    }
    /**
     * @description: 清除所有session缓存
     * @return {*}
     */
    static clearSession(){
        window.sessionStorage.clear()
    }
}

export default Storage
